(function () {
    var ANIMATION_DURATION = 300;

    function triggerChange(el) {
        if (!el) return;
        var evt;
        try {
            evt = new Event('change', { bubbles: true });
        } catch (e) {
            evt = document.createEvent('Event');
            evt.initEvent('change', true, true);
        }
        el.dispatchEvent(evt);
    }

    function parseMoney(text) {
        if (!text) return null;

        var match = text.match(/-?\d[\d\s.,]*/);
        if (!match) return null;

        var num = match[0].replace(/\s/g, '');
        var lastComma = num.lastIndexOf(',');
        var lastDot = num.lastIndexOf('.');
        var decimalSeparator = lastComma > lastDot ? ',' : '.';

        if (lastComma !== -1 || lastDot !== -1) {
            var thousandsSeparator = decimalSeparator === ',' ? /\./g : /,/g;
            num = num.replace(thousandsSeparator, '').replace(decimalSeparator, '.');
        }

        var val = parseFloat(num);
        return isNaN(val) ? null : val;
    }

    function formatMoney(val, template) {
        if (val === null || !template) return '';

        var match = template.match(/-?\d[\d\s.,]*/);
        if (!match) return template;

        var numberTemplate = match[0].trim();
        var trailingWhitespace = match[0].slice(numberTemplate.length);
        var lastComma = numberTemplate.lastIndexOf(',');
        var lastDot = numberTemplate.lastIndexOf('.');
        var decimalSeparator = lastComma > lastDot ? ',' : '.';
        var formattedValue = val.toFixed(2).replace('.', decimalSeparator);

        return template.slice(0, match.index) + formattedValue + trailingWhitespace + template.slice(match.index + match[0].length);
    }

    function findRoot(el) {
        var root = el;
        for (var i = 0; i < 15; i++) {
            if (!root || root === document) break;
            if (
                root.classList &&
                (root.classList.contains('product__info-container') ||
                    root.classList.contains('product__info-wrapper'))
            ) {
                return root;
            }
            root = root.parentNode;
        }
        return null;
    }

    document.addEventListener('DOMContentLoaded', function () {
        var rows = document.querySelectorAll('.quantity-tabs__row');
        if (!rows.length) return;

        for (var r = 0; r < rows.length; r++) {
            (function (row) {
                var tabs = row.querySelectorAll('.quantity-tabs__item');
                if (!tabs.length) return;

                var root = findRoot(row);
                if (!root) return;

                var manualQuantity = root.querySelector('.product__quantity');
                var manualInput = manualQuantity
                    ? manualQuantity.querySelector('.quantity__input')
                    : null;

                if (!manualQuantity || !manualInput) return;

                function getPriceElements() {
                    return {
                        sale: root.querySelector('.price-item--sale[data-money]'),
                        regular: root.querySelector('.price__regular .price-item--regular[data-money]'),
                        compare: root.querySelector('.price__compare .price-item--regular[data-money]'),
                        unit: root.querySelector('.unit-price span[data-info-variant]')
                    };
                }

                function resetMoneyElement(element) {
                    if (element) element.textContent = element.getAttribute('data-money');
                }

                function multiplyMoneyElement(element, qty) {
                    if (!element) return;

                    var baseMoneyText = element.getAttribute('data-money');
                    var baseValue = parseMoney(baseMoneyText);
                    if (baseValue === null) return;

                    element.textContent = formatMoney(baseValue * qty, baseMoneyText);
                }

                function resetPrices() {
                    var elements = getPriceElements();
                    resetMoneyElement(elements.sale);
                    resetMoneyElement(elements.regular);
                    resetMoneyElement(elements.compare);
                    if (elements.unit) elements.unit.textContent = elements.unit.getAttribute('data-info-variant');
                }

                function updatePricesByQty(qty) {
                    var q = parseInt(qty, 10);
                    if (!q || q <= 1) {
                        resetPrices();
                        return;
                    }

                    var elements = getPriceElements();
                    multiplyMoneyElement(elements.sale, q);
                    multiplyMoneyElement(elements.regular, q);
                    multiplyMoneyElement(elements.compare, q);

                    // The unit price (for example, €/l) remains a per-unit value.
                    if (elements.unit) elements.unit.textContent = elements.unit.getAttribute('data-info-variant');
                }

                function showManualQuantity() {
                    manualQuantity.classList.remove('is-collapsed');
                    manualQuantity.style.height = manualQuantity.scrollHeight + 'px';

                    setTimeout(function () {
                        manualQuantity.style.height = '';
                    }, ANIMATION_DURATION);

                    setTimeout(function () {
                        manualInput.value = 1;
                        triggerChange(manualInput);
                        resetPrices();
                    }, ANIMATION_DURATION);
                }

                function hideManualQuantityAndSetQty(qty) {
                    manualQuantity.style.height = manualQuantity.scrollHeight + 'px';

                    window.requestAnimationFrame(function () {
                        manualQuantity.classList.add('is-collapsed');
                        manualQuantity.style.height = '0px';
                    });

                    setTimeout(function () {
                        manualInput.value = qty;
                        triggerChange(manualInput);
                        updatePricesByQty(qty);
                    }, ANIMATION_DURATION);
                }

                function setActiveTab(active) {
                    for (var i = 0; i < tabs.length; i++) {
                        tabs[i].classList.remove('is-active');
                    }
                    active.classList.add('is-active');
                }

                for (var i = 0; i < tabs.length; i++) {
                    tabs[i].addEventListener('click', function () {
                        var qty = this.getAttribute('data-qty');
                        setActiveTab(this);

                        if (qty === 'any') {
                            showManualQuantity();
                        } else {
                            hideManualQuantityAndSetQty(qty);
                        }
                    });
                }

                manualInput.addEventListener('change', function () {
                    var activeTab = row.querySelector('.quantity-tabs__item.is-active');
                    if (!activeTab || activeTab.getAttribute('data-qty') !== 'any') return;
                    updatePricesByQty(this.value);
                });

                /* initial sync */
                var active = row.querySelector('.quantity-tabs__item.is-active');
                if (active) {
                    var initQty = active.getAttribute('data-qty');
                    if (initQty && initQty !== 'any') {
                        manualQuantity.classList.add('is-collapsed');
                        manualQuantity.style.height = '0px';
                        manualInput.value = initQty;
                        triggerChange(manualInput);
                        updatePricesByQty(initQty);
                    } else {
                        manualInput.value = 1;
                        triggerChange(manualInput);
                        resetPrices();
                    }
                }
            })(rows[r]);
        }
    });
})();
